/*
  Ingredient Atlas entry: the study list's filters, the topic buttons that
  jump to it and the photo credit button. Loaded only by the Atlas sections.
  The list itself is plain HTML from the theme, so it reads fine without
  this script; the filters stay hidden until it runs.
*/

if (!customElements.get('nr-atlas-studies')) {
  class NrAtlasStudies extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('tbody tr'));
      this.selects = Array.from(this.querySelectorAll('select[data-filter]'));
      this.count = this.querySelector('[data-count]');
      this.more = this.querySelector('[data-more]');
      this.countLow = this.querySelector('[data-count-low]');
      this.first = parseInt(this.dataset.first, 10) || 25;
      this.step = parseInt(this.dataset.step, 10) || this.first;
      this.limit = this.first;
      this.selects.forEach((s) =>
        s.addEventListener('change', () => {
          this.limit = this.first;
          this.render();
        })
      );
      this.querySelector('[data-more-button]')?.addEventListener('click', () => {
        this.limit += this.step;
        this.render();
      });
      this.querySelector('[data-filters]').hidden = false;
      this.render();
    }

    filterBy(name, value) {
      const select = this.selects.find((s) => s.dataset.filter === name);
      if (!select || !Array.from(select.options).some((o) => o.value === value)) return;
      select.value = value;
      this.limit = this.first;
      this.render();
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    isShown(row) {
      return this.selects.every((s) => {
        const v = s.value;
        if (v === 'all') return true;
        switch (s.dataset.filter) {
          case 'topic':
            return row.dataset.topics.includes(` ${v} `);
          case 'who':
            return row.dataset.who === v;
          case 'design':
            return (row.dataset.rct === '1') === (v === 'rct');
          case 'result':
            return (row.dataset.checked === '1') === (v === 'checked');
          default:
            return true;
        }
      });
    }

    render() {
      const hits = this.rows.filter((r) => this.isShown(r));
      const shown = Math.min(hits.length, this.limit);
      this.rows.forEach((r) => (r.hidden = true));
      hits.slice(0, shown).forEach((r) => (r.hidden = false));
      const filtered = this.selects.some((s) => s.value !== 'all');
      const countText = this.dataset.countText
        .replace('[shown]', shown.toLocaleString('en-GB'))
        .replace('[total]', hits.length.toLocaleString('en-GB'));
      this.count.textContent = countText;
      if (this.countLow) this.countLow.textContent = countText;
      if (filtered) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.textContent = this.dataset.clearText;
        clear.addEventListener('click', () => {
          this.selects.forEach((s) => (s.value = 'all'));
          this.limit = this.first;
          this.render();
        });
        this.count.append(' ', clear);
      }
      if (this.more) this.more.hidden = shown >= hits.length;
    }
  }
  customElements.define('nr-atlas-studies', NrAtlasStudies);
}

if (!customElements.get('nr-atlas-topics')) {
  class NrAtlasTopics extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-topic]');
        const list = document.querySelector('nr-atlas-studies');
        if (button && list) list.filterBy('topic', button.dataset.topic);
      });
    }
  }
  customElements.define('nr-atlas-topics', NrAtlasTopics);
}

if (!customElements.get('nr-atlas-credit')) {
  class NrAtlasCredit extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => this.toggle(!this.classList.contains('is-open')));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.toggle(false);
      });
      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.toggle(false);
      });
    }

    toggle(open) {
      this.classList.toggle('is-open', open);
      this.button.setAttribute('aria-expanded', open);
    }
  }
  customElements.define('nr-atlas-credit', NrAtlasCredit);
}

// The opening's version link opens the folded list of versions it points to
document.addEventListener('click', (event) => {
  if (!event.target.closest('a[href="#atlas-versions"]')) return;
  const list = document.querySelector('#atlas-versions details');
  if (list) list.open = true;
});
